import type { TOC } from '@ember/component/template-only'
import type { WithBoundArgs } from '@glint/template'
import { hash } from '@ember/helper'
import { BasicTableRow } from 'teacher-ui-client/components/stable-table/basic-table/row'
import type { ColumnObject, RowObject } from 'teacher-ui-client/components/stable-table/basic-table/cell'
import type { Config } from 'teacher-ui-client/components/stable-table/basic-table'

interface BodySignature {
  Element: HTMLTableSectionElement
  Args: {
    rows: RowObject[]
    columns: ColumnObject[]
    config?: Config
  }
  Blocks: {
    default: [
      { row: WithBoundArgs<typeof BasicTableRow, 'rowObject' | 'columns' | 'rowIndex' | 'config'> },
      { rowObject: RowObject; rowIndex: number },
    ]
  }
}

export const BasicTableBody: TOC<BodySignature> = <template>
  <tbody data-test-basic-table-body ...attributes>
    {{#each @rows as |rowObject index|}}
      {{#let (component BasicTableRow rowObject=rowObject columns=@columns rowIndex=index config=@config) as |row|}}
        {{#if (has-block)}}
          {{yield (hash row=row) (hash rowObject=rowObject rowIndex=index)}}
        {{else}}
          {{row}}
        {{/if}}
      {{/let}}
    {{/each}}
  </tbody>
</template>

export default BasicTableBody
